import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ItemCategory } from '@planone/bau365/data-access-user';

import { ItemCategoryOption } from '../page-watchlist/page-watchlist.model';

@Component({
  selector: 'bau365-watchlist-filter-dialog',
  templateUrl: './watchlist-filter-dialog.component.html',
  styleUrls: ['./watchlist-filter-dialog.component.scss'],
})
export class WatchlistFilterDialogComponent {
  @Input() itemCategories: ItemCategoryOption[] | undefined | null;
  @Input() itemCategory: ItemCategory | undefined | null;

  @Output()
  itemCategoryChanged = new EventEmitter<ItemCategory>();

  onSelectionChanged(event: { value: ItemCategory }) {
    this.itemCategoryChanged.emit(event.value);
  }

  identifyItemCategory(_index: number, item: ItemCategoryOption): string {
    return item.category;
  }
}
